import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, DatePicker,} from 'antd';
import { useBnsFanKuiJianChaUpdateQuery, useBnsFanKuiJianChaUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import MediaForm from '../media/MediaForm';
import GetUser from '../../cpn/GetUser';
import dayjs from 'dayjs';
function FeedbackEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bg_content:''
    }); 
    const {data,isSuccess} = useBnsFanKuiJianChaUpdateQuery({bfkjc_id:props.bfkjc_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bfkjc_dept_id:data.Result.bfkjc_dept_id,                  
                    bfkjc_meijie_id:data.Result.bfkjc_meijie_id,
                    bfkjc_fuzhuren_id:data.Result.bfkjc_fuzhuren_id,
                    bfkjc_name:data.Result.bfkjc_name,   
                    bfkjc_jihuariqi:dayjs(data.Result.bfkjc_jihuariqi),  
                })
                setInfo(prevState=>({...prevState,
                    bfkjc_dept_id:data.Result.bfkjc_dept_id,                    
                    bfkjc_dept_name:data.Result.bfkjc_dept_name, 
                    bfkjc_meijie_id:data.Result.bfkjc_meijie_id,                    
                    bfkjc_meijie_name:data.Result.bfkjc_meijie_name,                    
                    bfkjc_fuzhuren_id:data.Result.bfkjc_fuzhuren_id,                    
                    bfkjc_fuzhuren_name:data.Result.bfkjc_fuzhuren_name,  
                    bfkjc_name:data.Result.bfkjc_name,                    
                    bfkjc_jihuariqi:data.Result.bfkjc_jihuariqi,                    
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsFanKuiJianChaUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改技术文档'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({                      
                        "bfkjc_uid" : localStorage.getItem('eu_id'),
                        "bfkjc_uname" : localStorage.getItem('eu_name'),
                        "bfkjc_dept_id" : info.bfkjc_dept_id,
                        "bfkjc_dept_name" : info.bfkjc_dept_name,
                        "bfkjc_e_id" : localStorage.getItem('e_id'),
                        "bfkjc_fuzhuren_id" : info.bfkjc_fuzhuren_id,
                        "bfkjc_fuzhuren_name" : info.bfkjc_fuzhuren_name,
                        "bfkjc_jihuariqi" : info.bfkjc_jihuariqi,
                        "bfkjc_meijie_id" : info.bfkjc_meijie_id,
                        "bfkjc_meijie_name" : info.bfkjc_meijie_name,
                        "bfkjc_name" : info.bfkjc_name,     
                        bfkjc_id:props.bfkjc_id,                                 
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GetUserDept
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bfkjc_dept_id:e,bfkjc_dept_name:f}))
                        }}
                        name='bfkjc_dept_id'
                    />                
                    <MediaForm
                        wrapperCol={{span:10}}
                        required
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bfkjc_meijie_id:e,bfkjc_meijie_name:f.label}))
                        }}
                        name='bfkjc_meijie_id'
                    />
                    <GetUser
                        label='负责人'
                        required
                        wrapperCol={{span:10}} 
                        getUser={(e,f) => {
                            setInfo(prevState=>({...prevState,bfkjc_fuzhuren_id:e,bfkjc_fuzhuren_name:f}))
                        }}
                        name='bfkjc_fuzhuren_id'
                    />
                    <Form.Item
                        wrapperCol={{span:20}} 
                        style={{marginBottom:"0"}}
                        label='计划日期'required
                    >
                        <Form.Item name="bfkjc_jihuariqi">
                            <DatePicker 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bfkjc_jihuariqi:dayjs(e).format('YYYY-MM-DD')}))}} 
                            />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item name="bfkjc_name" label='检查内容' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bfkjc_name:e.target.value}))}}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default FeedbackEdit